import { render, staticRenderFns } from "./InputExtUI.vue?vue&type=template&id=23ea11d5&"
import script from "./InputExtUI.vue?vue&type=script&lang=js&"
export * from "./InputExtUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports